import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { MuiGlobal } from '@lsoft/mui';
import { useShopSnackbar } from '../../hooks/useShopSnackbar';
import { getTranslation } from '@lsoft/translate';
import { trSomethingWentWrongPleaseTryAgainLater } from '../../components/CustomerCard/CustomerCardView.tr';
import { useRouter } from 'next/router';
import { google_maps_place_details_get } from '@lsoft/shared/backend/google_maps/google_maps';

const Context = React.createContext(null);
Context.displayName = 'GoogleMapsPlaceDetails.Context';

const Container = ({ children }) => {
	const throwSnackbar = useShopSnackbar();
	const { locale } = useRouter();
	const [data, setData] = useState(null);

	const places_id = MuiGlobal.get('placesId', null);

	useEffect(() => {
		const as = async () => {
			try {
				const place_details = await google_maps_place_details_get({
					places_id: places_id,
				});
				setData(place_details);
			} catch (e) {
				throwSnackbar({
					exception: e,
					msg: getTranslation(trSomethingWentWrongPleaseTryAgainLater, locale),
					variant: 'error',
				});
				console.error(e);
			}
		};
		as();
	}, []);
	if (_.isNil(data)) return null;
	return <Context.Provider value={data}>{children}</Context.Provider>;
};
const GoogleMapsPlaceDetails = {
	Container,
	Context,
};

export { GoogleMapsPlaceDetails };
